import { format as d3format } from "d3-format";

const INT = "INT";
const DECIMAL = "DECIMAL";
const DECIMAL_SMALL = "DECIMAL_SMALL";

const FALLBACK = "N/A";

const FORMATS = {
  [INT]: ",d",
  [DECIMAL]: ",.3f",
  [DECIMAL_SMALL]: ",.4f"
};
const SMALL_FORMATS = {
  [INT]: ",d",
  [DECIMAL]: ",.4f",
  [DECIMAL_SMALL]: ",.5f"
};

export const formatNumber = (num, type = INT, cat = "default") => {
  if (num === null || num === undefined || isNaN(num)) return FALLBACK;
  if (cat === "small") {
    const fmt = SMALL_FORMATS[type] || SMALL_FORMATS[INT];
    const formatter = d3format(fmt);
    return formatter(num);
  }
  const fmt = FORMATS[type] || FORMATS[INT];
  const formatter = d3format(fmt);
  return formatter(num);
};
